export default __webpack_public_path__ + "static/media/16.37a485ff.jpg";